import React, { useState } from "react";
import { useEffect } from "react";
import { Wrap, SublineDec, SublineInc } from "./styled";
import ee from "@/utils/ee";
import { AnimatePresence } from "framer-motion";

const GlobalProgress = () => {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onStart = () => setVisible(true);
    ee.on("global_progress/start", onStart);
    const onEnd = () => setVisible(false);
    ee.on("global_progress/end", onEnd);
    return () => {
      ee.off("global_progress/start", onStart);
      ee.off("global_progress/end", onEnd);
    };
  }, []);
  return (
    <AnimatePresence>
      {visible && (
        <Wrap
          exit={{
            opacity: 0,
          }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.4 }}
        >
          <SublineInc />
          <SublineDec />
        </Wrap>
      )}
    </AnimatePresence>
  );
};

export default GlobalProgress;
